import { RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const formatRelative = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const diffSec = Math.max(0, Math.round((Date.now() - d.getTime()) / 1000));
  if (diffSec < 60) return `${diffSec}sn önce`;
  if (diffSec < 3600) return `${Math.round(diffSec / 60)}dk önce`;
  if (diffSec < 86400) return `${Math.round(diffSec / 3600)}sa önce`;
  return d.toLocaleString();
};

const MtrPanel = ({ data, pending, onRefresh, error }) => {
  const hops = data?.hops || [];
  const timestamp = data?.timestamp;
  const hasData = hops.length > 0;

  return (
    <div className="mt-3 pt-3 border-t border-border" data-testid="mtr-panel">
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs text-muted-foreground">
          Son tarama: <span className="font-mono">{formatRelative(timestamp)}</span>
        </p>
        <Button
          size="sm"
          variant="outline"
          className="h-7 px-2 text-xs gap-1"
          onClick={onRefresh}
          disabled={pending}
        >
          {pending ? (
            <Loader2 className="w-3 h-3 animate-spin" />
          ) : (
            <RefreshCw className="w-3 h-3" />
          )}
          {pending ? "Taranıyor..." : "Şimdi tara"}
        </Button>
      </div>

      {error && (
        <p className="text-xs text-red-500 mb-2">{error}</p>
      )}

      {hasData ? (
        <div className="overflow-x-auto">
          <table className="w-full text-xs font-mono">
            <thead>
              <tr className="text-muted-foreground border-b border-border">
                <th className="text-left py-1 pr-2">#</th>
                <th className="text-left py-1 pr-2">Hop IP</th>
                <th className="text-left py-1 pr-2">Hostname</th>
                <th className="text-right py-1 pr-2">Loss%</th>
                <th className="text-right py-1">Avg ms</th>
              </tr>
            </thead>
            <tbody>
              {hops.map((h, idx) => {
                const missing = !h.ip;
                const lossy = (h.loss_percent || 0) > 0;
                return (
                  <tr
                    key={idx}
                    className={`border-b border-border/50 ${
                      missing ? "text-muted-foreground" : lossy ? "text-red-400" : "text-foreground"
                    }`}
                  >
                    <td className="py-1 pr-2">{h.hop}</td>
                    <td className="py-1 pr-2">{h.ip || "*"}</td>
                    <td className="py-1 pr-2 truncate max-w-[140px]">{h.hostname || "—"}</td>
                    <td className="py-1 pr-2 text-right">
                      {h.loss_percent !== undefined ? `${h.loss_percent.toFixed(1)}` : "—"}
                    </td>
                    <td className="py-1 text-right">
                      {h.avg_ms !== null && h.avg_ms !== undefined ? h.avg_ms.toFixed(2) : "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-xs text-muted-foreground py-3 text-center">
          {pending ? "İlk MTR sonucu bekleniyor..." : 'MTR verisi yok — "Şimdi tara"\'ya basın.'}
        </p>
      )}
    </div>
  );
};

export default MtrPanel;
